// sw.js
// This file will be populated by the workbox-cli in the build npm script.
